import * as React from 'react';

import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';

type ChipProps = MuiChipProps;

export const Chip: React.FC<ChipProps> = ({ onClick, onDelete, sx, ...props }) => {
  const hasClick = typeof onClick === 'function';
  const hasDelete = typeof onDelete === 'function';
  const interactive = hasClick || hasDelete;

  return (
    <MuiChip
      {...props}
      clickable={hasClick}
      onClick={hasClick ? onClick : undefined}
      onDelete={hasDelete ? onDelete : undefined}
      sx={interactive ? sx : { pointerEvents: 'none', ...sx }}
    />
  );
};
